import styled, { css } from 'styled-components';
import { variants, th } from 'style/theme';

export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px;
  border: 1px solid;
  border-radius: 16px;

  ${variants('variant', {
    warning: css`
      border-color: ${th('colors.porsche')};
      background-color: ${th('colors.porsche+4')};
    `,
    info: css`
      border-color: ${th('colors.fountainBlue+2')};
      background-color: ${th('colors.fountainBlue+4')};
    `
  })};

  > svg {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }
`;
